/** Mock SSOT for HotelsRiver hotels-results UI demo — no API. */

export const INITIAL_APPLIED_SEARCH = {
  destinationId: "larnaca",
  destinationLabel: "לרנקה",
  dateRangeLabel: "15–19 בנובמבר",
  dateRangeInput: "15/11/2026 - 19/11/2026",
  adults: 2,
  children: 0,
  infants: 0,
  rooms: 1,
  occupancyLabel: "2 מבוגרים · חדר אחד",
  checkIn: "2026-11-15",
  checkOut: "2026-11-19",
  nights: 4,
};

export function formatSearchSummary(search) {
  if (!search) return "";
  const dest = search.destinationLabel || "יעד";
  const dates = search.dateRangeLabel || search.dateRangeInput || "";
  const pax = search.occupancyLabel || "";
  return [dest, dates, pax].filter(Boolean).join(" · ");
}

export function cloneSearch(search) {
  return { ...search };
}

export function validateSearchDraft(draft) {
  if (!draft?.destinationId) return "נא לבחור יעד לחיפוש";
  if (!draft?.dateRangeInput && !draft?.dateRangeLabel) return "נא לבחור תאריכים";
  if (!Number(draft?.adults) || Number(draft.adults) < 1) return "נא להגדיר לפחות מבוגר אחד";
  if (!Number(draft?.rooms) || Number(draft.rooms) < 1) return "נא להגדיר לפחות חדר אחד";
  return null;
}

export const MOCK_FILTER_DESTINATIONS = [
  { id: "larnaca", label: "לרנקה", count: 86 },
  { id: "paphos", label: "פאפוס", count: 64 },
  { id: "limassol", label: "לימסול", count: 71 },
  { id: "ayianapa", label: "אגיה נאפה", count: 52 },
  { id: "nicosia", label: "ניקוסיה", count: 28 },
];

export const MOCK_BOARD_OPTIONS = [
  { id: "ro", label: "לינה בלבד" },
  { id: "bb", label: "לינה וארוחת בוקר", shortLabel: "ארוחת בוקר" },
  { id: "hb", label: "חצי פנסיון" },
  { id: "fb", label: "פנסיון מלא" },
  { id: "ai", label: "הכל כלול" },
];

export const MOCK_BOARD_TOP_FILTERS = [
  { id: "all", label: "בסיס אירוח" },
  ...MOCK_BOARD_OPTIONS,
];

export const MOCK_STAR_OPTIONS = [
  { id: 5, label: "5 כוכבים" },
  { id: 4, label: "4 כוכבים" },
  { id: 3, label: "3 כוכבים" },
  { id: 2, label: "2 כוכבים ומטה" },
];

export const MOCK_PRICE_FILTERS = [
  { id: "all", label: "מחיר: הכל", min: 0, max: Infinity },
  { id: "lt600", label: "עד $600", min: 0, max: 600 },
  { id: "600-900", label: "$600–$900", min: 600, max: 900 },
  { id: "900-1200", label: "$900–$1,200", min: 900, max: 1200 },
  { id: "gt1200", label: "מעל $1,200", min: 1200, max: Infinity },
];

export const MOCK_AGENT_QUICK_FILTERS = [
  { id: "immediate", label: "אישור מיידי" },
  { id: "refundable", label: "ניתן לביטול" },
  { id: "beach", label: "קרוב לחוף" },
  { id: "pool", label: "בריכה" },
];

const FX_USD_TO_ILS = 3.089;

export function formatUsd(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `$${Math.round(n).toLocaleString("en-US")}`;
}

export function formatIls(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `₪${Math.round(n).toLocaleString("he-IL")}`;
}

export function usdToIls(usd) {
  return Number(usd) * FX_USD_TO_ILS;
}

export function getHotelTotalUsd(hotel, rooms = 1) {
  return Number(hotel?.priceTotalUsd || 0) * Math.max(1, Number(rooms) || 1);
}

export function getHotelPerPersonUsd(hotel, adults = 2) {
  const total = Number(hotel?.priceTotalUsd || 0);
  const pax = Math.max(1, Number(adults) || 2);
  return total / pax;
}

export const MOCK_HOTELS = [
  {
    id: "htl-sun-hall",
    hotelName: "Sun Hall Hotel",
    stars: 4,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "טיילת לרנקה",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Superior Sea View",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 745,
    currency: "USD",
    commissionPercent: 12,
    immediateConfirm: true,
    refundable: true,
    beachfront: true,
    hasPool: true,
    distanceLabel: "120 מ׳ מהחוף",
    amenities: ["Wi-Fi", "חניה", "בריכה"],
    imageUrl:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-radisson",
    hotelName: "Radisson Beach Resort Larnaca",
    stars: 5,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "Finikoudes",
    boardId: "hb",
    boardLabel: "חצי פנסיון",
    roomType: "Deluxe Room",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 942,
    currency: "USD",
    commissionPercent: 14,
    immediateConfirm: true,
    refundable: false,
    beachfront: true,
    hasPool: true,
    distanceLabel: "על החוף",
    amenities: ["ספא", "חדר כושר", "בריכה"],
    imageUrl:
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-senatore",
    hotelName: "The Senatore Hotel",
    stars: 4,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "מרכז העיר",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Standard Double",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 729,
    currency: "USD",
    commissionPercent: 11,
    immediateConfirm: true,
    refundable: true,
    beachfront: false,
    hasPool: true,
    distanceLabel: "650 מ׳ מהחוף",
    amenities: ["Wi-Fi", "בר", "חניה"],
    imageUrl:
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-livadhiotis",
    hotelName: "Livadhiotis City Hotel",
    stars: 3,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "מרכז",
    boardId: "ro",
    boardLabel: "לינה בלבד",
    roomType: "Twin Room",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 498,
    currency: "USD",
    commissionPercent: 10,
    immediateConfirm: true,
    refundable: true,
    beachfront: false,
    hasPool: false,
    distanceLabel: "900 מ׳ מהחוף",
    amenities: ["Wi-Fi", "דלפק 24/7"],
    imageUrl:
      "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-golden-bay",
    hotelName: "Golden Bay Beach Hotel",
    stars: 5,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "Voroklini",
    boardId: "ai",
    boardLabel: "הכל כלול",
    roomType: "Family Suite",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 1280,
    currency: "USD",
    commissionPercent: 13,
    immediateConfirm: false,
    refundable: false,
    beachfront: true,
    hasPool: true,
    distanceLabel: "על החוף",
    amenities: ["הכל כלול", "בריכות", "ילדים"],
    imageUrl:
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-castle",
    hotelName: "Castle Resort & Spa",
    stars: 4,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "Pyla",
    boardId: "hb",
    boardLabel: "חצי פנסיון",
    roomType: "Garden View",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 868,
    currency: "USD",
    commissionPercent: 12,
    immediateConfirm: true,
    refundable: true,
    beachfront: true,
    hasPool: true,
    distanceLabel: "80 מ׳ מהחוף",
    amenities: ["ספא", "טניס", "בריכה"],
    imageUrl:
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-eleonora",
    hotelName: "Eleonora Hotel Apartments",
    stars: 3,
    city: "לרנקה",
    country: "קפריסין",
    destinationId: "larnaca",
    area: "Mackenzie",
    boardId: "bb",
    boardLabel: "ארוחת בוקר",
    roomType: "Studio Apartment",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 556,
    currency: "USD",
    commissionPercent: 9,
    immediateConfirm: true,
    refundable: true,
    beachfront: false,
    hasPool: true,
    distanceLabel: "350 מ׳ מהחוף",
    amenities: ["מטבחון", "בריכה", "Wi-Fi"],
    imageUrl:
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=800&q=80&auto=format&fit=crop",
  },
  {
    id: "htl-saint-raphael",
    hotelName: "Saint Raphael Resort",
    stars: 5,
    city: "לימסול",
    country: "קפריסין",
    destinationId: "limassol",
    area: "Amathus",
    boardId: "hb",
    boardLabel: "חצי פנסיון",
    roomType: "Sea View Room",
    nights: 4,
    rooms: 1,
    dateRangeLabel: "15–19 בנובמבר 2026",
    priceTotalUsd: 1145,
    currency: "USD",
    commissionPercent: 15,
    immediateConfirm: false,
    refundable: true,
    beachfront: true,
    hasPool: true,
    distanceLabel: "על החוף",
    amenities: ["ספא", "גולף", "בריכה"],
    imageUrl:
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800&q=80&auto=format&fit=crop",
  },
];
